import {
  MobileMultiComboBox,
  MobileMultiComboBoxProps,
  ItemProp,
} from '@florencelabs/multi-combo-box';
import { ReactElement } from 'react';
import { useSearchFilters } from '@provider-directory/contexts/SearchFiltersContext';

/**
 * Wraps a MobileMultiComboBox to ensure it closes nicely when the Search Filters Drawer does.
 */
export const DrawerAwareMobileMultiComboBox = <T extends ItemProp>(
  props: MobileMultiComboBoxProps<T> & { closeDrawerOnClose?: boolean },
): ReactElement => {
  const { isOpen: isDrawerOpen, setIsOpen } = useSearchFilters();
  const { onClose, closeDrawerOnClose = true } = props;

  return (
    <MobileMultiComboBox
      {...props}
      isOpen={isDrawerOpen && props.isOpen}
      showBackButton={true}
      onClose={() => {
        onClose?.();
        if (closeDrawerOnClose) {
          setIsOpen(false);
        }
      }}
    />
  );
};
